export const STATUS_ID = 'templateStatus';
